import { ApiMethodType } from '@celito.clients/enums';
import {
  SortConfig,
  TemporaryUnifyDefaultAndUserFilters,
} from '@celito.clients/list-view-engine';
import { performRequest } from '@celito.clients/network';
import { CourseViewData } from '@celito.clients/types';
import Endpoints from 'libs/core/src/config/endpoint';
import { RulesComponentListViewFilter } from 'libs/shared/src/lib/rules-component/types/rules-component.types';

import { defaultSortConfig } from '../config';

export const getCourseViewData = async (
  paginationData: {
    pageLimit: number;
    page: number;
  },
  configData: {
    filters: RulesComponentListViewFilter;
    sortConfig?: SortConfig;
  },
  signal?: AbortSignal
) => {
  const finalFilters = TemporaryUnifyDefaultAndUserFilters(
    undefined,
    configData.filters
  );
  const response = await performRequest<CourseViewData>(
    `${Endpoints.COURSE_VIEW_METADATA_URL}`,
    ApiMethodType.POST,
    {
      filters: finalFilters,
      sort: configData.sortConfig ?? defaultSortConfig,
    },
    {
      limit: paginationData.pageLimit,
      page: paginationData.page,
      getMaxMajorVersionOnly: true,
    },
    undefined,
    signal
  );
  return response.data;
};
